import { Checkbox, CardContent, Typography, TextField } from "@mui/material";
import ImageUpload from "./ImageUpload";
import CloseIcon from "@mui/icons-material/Close";

import { ReactComponent as DeleteIcon } from "../../myfin_v2/assets/icons/delete_icon_primary.svg";
import { ReactComponent as SearchIcon } from "../../myfin_v2/assets/icons/searchPri.svg";
import buttoncss from "../../myfin_v2/css/button.module.css";
import commoncss from "../../myfin_v2/css/common.module.css";
import adminPortalCss from "../../myfin_v2/css/adminportal.module.css";
import { Button } from "../../myfin_v2/elements/Button";
import InputGroup from "../../myfin_v2/elements/InputGroup";

const AddHeaders = ({
  sampleHeaders,
  headers,
  handleCheckBox,
  handleHeaders,
  uploadImages,
  close,
  popHeaderCount,
  key
}) => {

  let remainingHeaders = close !== 0 ? sampleHeaders.filter(ele => !headers.slice(0, close).map(item => item.sheets).flat().includes(ele)) : sampleHeaders;
  if (remainingHeaders.length === 0 || (remainingHeaders.length === 1 && remainingHeaders.includes('All Pages'))) {
    popHeaderCount(close);
  }
  const label = { inputProps: { "aria-label": "Checkbox demo" } };

  const handleChecked = (close, header) => {
    const headerSheet = headers.find(ele => ele.header === close);
    if (headerSheet === undefined) {
      return false
    }
    let RefinedSampleHeaders = remainingHeaders.filter((head) => head !== 'All Pages');
    let all_present = RefinedSampleHeaders.every(ele => headerSheet.sheets.includes(ele))
    if (headerSheet) {
      return headerSheet.sheets.includes(header) || headerSheet.sheets.includes('All Pages') || all_present || false;
    } else {
      return false
    }
  }

  return (
    <CardContent>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between", // Distributes space between text and icon
          alignItems: "center", // Vertically centers the content
          padding: "0 10px", // Adds padding on the left and right
        }}
      >

        <span className={commoncss.label3}>
          Add Header to:</span>
        {close !== 0 && <CloseIcon
          className="custom-redcolor ml-1 mt-1"
          style={{ cursor: "pointer", backgroundColor: 'lightpink', borderRadius: '50%' }}
          onClick={() => { popHeaderCount(close) }}
        />}
      </div>
      <div className="d-flex flex-wrap p-2 py-3" style={{ gap: "10px" }}>
        {remainingHeaders.map((header, index) => (
          <div>
            <input type="checkbox"
              name="sheet1"
              value={header}
              onChange={(e) => { console.log("e, close", e, close); handleCheckBox(e, close) }}
              checked={
                handleChecked(close, header)
              }
              className={adminPortalCss.customCheckbox}
            /> <span className={`${commoncss.label6} ${commoncss.headingColor} ${commoncss.vaSuper} ${commoncss.fs16}`}>{header}</span>
          </div>
        ))}
      </div>
      <InputGroup
        inputs={[
          <>
            <textarea
              className={commoncss.fs15}
              rows={1}
              name="header1"
              placeholder="Header Data"
              onChange={(e) => { console.log("e, close", e, close); handleHeaders(e, close) }}
            />
          </>,
        ]}
      />
      {/* <div className="mt-2 ">
        <TextField
          onChange={(e) => {console.log("e, close",e, close);handleHeaders(e, close)}}
          multiline
          maxRows={5}
          name="header1"
          placeholder="Header Data"
          variant="outlined"
          className="w-100 finalise-textcolor rounded"
        />
      </div> */}
      <div>
        <ImageUpload uploadImages={uploadImages} headerNumber={close} name={"image1"} />
      </div>
    </CardContent >
  );
};

export default AddHeaders;
